import React from "react";
import { TFunction } from "i18next";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";

type Props = {
    moneyCorrespondence: string;
    setMoneyCorrespondence: (v: string) => void;
    setIsEdited: (v: boolean) => void;
    isConsult?: boolean;
    t: TFunction;
};

export default function MoneyCorrespondenceInput({
    moneyCorrespondence,
    setMoneyCorrespondence,
    setIsEdited,
    isConsult,
    t,
}: Props) {
    return (
        <AvGroup className={isConsult ? "pe-none__clz" : ""}>
            <StyledLabel className="required__clz mt-3" htmlFor="name">
                {t("Money correspondence")}
            </StyledLabel>
            <StyledTextInput
                data-testid="fidelity-franchise-money-correspondence-input"
                autoComplete="off"
                id="Money correspondence"
                name="Money correspondence"
                placeholder={t("Write")}
                type="text"
                onChange={() => {
                    setIsEdited(true);
                    setMoneyCorrespondence("1");
                }}
                className="fed_inp_FRmoneyCorrespondence not-allowed-icon__clz"
                value={moneyCorrespondence}
            />
        </AvGroup>
    );
}
